export const FONT_WEIGHT_300 = '300';

export const FONT_WEIGHT_400 = '400';

export const FONT_WEIGHT_500 = '500';

export const FONT_WEIGHT_600 = '600';

export const FONT_WEIGHT_700 = '700';

const BasicFontWeight = {
    FONT_WEIGHT_300,
    FONT_WEIGHT_400,
    FONT_WEIGHT_500,
    FONT_WEIGHT_600,
    FONT_WEIGHT_700,
};

export default BasicFontWeight;
